var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "k-search",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.search($event)
        }
      }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchedValue,
            expression: "searchedValue"
          }
        ],
        staticClass: "k-search__input",
        attrs: { type: "text", placeholder: _vm.placeholder },
        domProps: { value: _vm.searchedValue },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchedValue = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("button", { staticClass: "k-search__button" }, [
        _c("svg", { attrs: { role: "img", width: "18", height: "18" } }, [
          _c("use", {
            attrs: {
              fill: "currentColor",
              "xlink:href": "/images/spritesheet.svg#magnify-glass"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }